module.exports = __webpack_public_path__ + "static/media/nobody_m.original.4b508f06.jpg";